import Vue from "vue";

const EventBusNavbar = new Vue();
const EventBusCase = new Vue();
const EventBusSidebar = new Vue();
const EventProjectLanguage = new Vue();
const EventUnauthorizedUserPopup = new Vue();
const EventValidationForm = new Vue();
const EventSideMenu = new Vue();
const EventSearch = new Vue();
const EventStepFrom = new Vue();
const EventOpenFilter = new Vue();
const EventGlobalSearch = new Vue();
const EventManagementPage = new Vue();
const EventBackToTopButton = new Vue();
const EventCurdSideMenu = new Vue();
const EventUserDashboard = new Vue();
const EventManagementContent = new Vue();
const EventButton = new Vue();

export {
	EventBusNavbar,
	EventBusCase,
	EventBusSidebar,
	EventProjectLanguage,
	EventUnauthorizedUserPopup,
	EventValidationForm,
	EventSideMenu,
	EventSearch,
	EventStepFrom,
	EventOpenFilter,
	EventGlobalSearch,
	EventManagementPage,
	EventBackToTopButton,
	EventCurdSideMenu,
	EventUserDashboard,
	EventManagementContent,
	EventButton
};
